import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Rename = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.33325 3.16699C4.05711 3.16699 3.83325 3.39085 3.83325 3.66699C3.83325 3.94313 4.05711 4.16699 4.33325 4.16699H7.49992V12.3337C7.49992 12.6098 7.72378 12.8337 7.99992 12.8337C8.27606 12.8337 8.49992 12.6098 8.49992 12.3337V4.16699H11.6666C11.9427 4.16699 12.1666 3.94313 12.1666 3.66699C12.1666 3.39085 11.9427 3.16699 11.6666 3.16699H7.99992H4.33325Z"
      />
    </svg>
  )
})

export default Rename
